import { render, staticRenderFns } from "./DashboardCoupon.vue?vue&type=template&id=59a31573&"
import script from "./DashboardCoupon.vue?vue&type=script&lang=js&"
export * from "./DashboardCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports